import React from 'react';
import styled from '@emotion/styled';
import {
	ImageWrap,
	IMarkdownRenderers,
	ITheme,
	Markdown,
	MarkdownRenderContext,
} from '../../../../../../ui';
import { useTranslation } from '../../../../../shared/i18n/translate/useTranslation';
import { StyledDialogMain } from '../../../../../shared/components/dialog';
import { CustomQuickLinkParagraph } from '../../../../../shared/markdown/CustomQuickLinkParagraph';
import { renderers as defaultRenderers } from '../../../../../shared/markdown/renderers';
import { IParkingProduct } from '../../../../domain/parking-product/models/IParkingProduct';
import Responsive from '../../../../../../ui/utils/Responsive';
import { markdownListStyles } from '../../../../../content-sections/ui/components/markdownListStyles';

interface IParkingProductDetailsMainProps {
	parkingProduct: IParkingProduct;
}

const StyledParkingProductDetailsMain = styled(StyledDialogMain)<{}, ITheme>`
	${markdownListStyles}
`;

const renderers: IMarkdownRenderers = {
	...defaultRenderers,
	p: CustomQuickLinkParagraph,
};

export const ParkingProductDetailsMain = ({
	parkingProduct,
}: IParkingProductDetailsMainProps) => (
	<MarkdownRenderContext.Provider value={renderers}>
		<StyledParkingProductDetailsMain wideContent>
			<Markdown source={parkingProduct.description} />
			<ParkingProductMap imageSrc={parkingProduct.map} />
		</StyledParkingProductDetailsMain>
	</MarkdownRenderContext.Provider>
);

interface IParkingProductMapProps {
	imageSrc?: string;
}

const ParkingProductMap = ({ imageSrc }: IParkingProductMapProps) => {
	const { t } = useTranslation();

	if (!imageSrc) return null;

	return (
		<ImageWrap>
			<StyledParkingProductMapImage
				src={imageSrc}
				alt={t('web_parking_product_map_image_alt_text')}
			/>
		</ImageWrap>
	);
};

const StyledParkingProductMapImage = styled.img`
	max-width: 100%;
	margin-top: 24px;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		margin-top: 8px;
	}
`;
